import { PageHeader } from '@portals-platform/ui';
import { CertificatesTable } from '../components/certificates-table/certificates-table.js';
import { PortalShell } from '../components/portal-shell.js';

export function CertificatesPage() {
  return (
    <PortalShell activeId="certificates" pageTitle="Certificates">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader title="Certificates" description="View and manage certificate requests." />
        <CertificatesTable />
      </div>
    </PortalShell>
  );
}
